import createValidator, { registerType } from 'typecheck.macro';

export type FlagrData = null | FlagrVariant;

interface FlagrVariant {
  key: string;
  attachment: unknown;
}

export interface FlagrEntity {
  id: string;
  type?: string;
  context?: Record<string, unknown>;
}

export const EvalResultValidator = createValidator<EvalResult>();

export const FlagrFlagValidator = createValidator<FlagrFlag[]>();

export const BatchEvalResultValidator = createValidator<BatchEvalResult>();

registerType('EvalResult');
registerType('FlagrFlag');
registerType('BatchEvalResult');

export interface EvalResult {
  /** @format int64 */
  flagID?: number;
  flagKey?: string;
  /** @format int64 */
  flagSnapshotID?: number;
  /** @format int64 */
  segmentID?: number;
  /** @format int64 */
  variantID?: number;
  variantKey?: string;
  variantAttachment?: unknown;
  evalContext?: EvalContext;
  timestamp?: string;
}

export interface BatchEvalResult {
  evaluationResults: EvalResult[];
}

export interface EvalContext {
  /** entityID is used to deterministically at random to evaluate the flag result. If it's empty, flagr will randomly generate one. */
  entityID?: string;
  entityType?: string;
  entityContext?: { [key: string]: unknown };
  enableDebug?: boolean;
  /**
   * flagID
   * @format int64
   * @min 1
   */
  flagID?: number;
  /** flagKey. flagID or flagKey will resolve to the same flag. Either works. */
  flagKey?: string;
  /** flagTags. flagTags looks up flags by tag. Either works. */
  flagTags?: string[];
  /** determine how flagTags is used to filter flags to be evaluated. OR extends the evaluation to those which contains at least one of the provided flagTags or AND limit the evaluation to those which contains all the flagTags. */
  flagTagsOperator?: 'ANY' | 'ALL';
}

export interface FlagrTag {
  id: number;
  value: string;
}

export interface FlagrConstraint {
  id: number;
  property: string;
  operator: string;
  value: string;
}

export interface FlagrDistribution {
  id: number;
  percent: number;
  variantKey: string;
  variantID: number;
}

export interface FlagrSegment {
  id: number;
  description: string;
  constraints: FlagrConstraint[];
  distributions: FlagrDistribution[];
  rank: number;
  rolloutPercent: number;
}

export interface FlagrFlag {
  id: string;
  key: string;
  description: string;
  enabled: boolean;
  tags: FlagrTag[];
  segments: FlagrSegment[];
  variants: FlagrVariant[];
}
